module.exports = __webpack_public_path__ + "img/aboutUsHomeCart2.2c22d5f9.png";